var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 62.5C56.9036 62.5 62.5 56.9036 62.5 50C62.5 43.0964 56.9036 37.5 50 37.5C43.0964 37.5 37.5 43.0964 37.5 50C37.5 56.9036 43.0964 62.5 50 62.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6876 48.9375C93.0121 39.4302 86.6313 31.2082 78.3339 25.2878C70.0364 19.3674 60.186 16.008 50.0001 15.625C39.8142 16.008 29.9638 19.3674 21.6664 25.2878C13.3689 31.2082 6.98814 39.4302 3.31264 48.9375C3.06441 49.6241 3.06441 50.3759 3.31264 51.0625C6.98814 60.5698 13.3689 68.7918 21.6664 74.7122C29.9638 80.6326 39.8142 83.992 50.0001 84.375C60.186 83.992 70.0364 80.6326 78.3339 74.7122C86.6313 68.7918 93.0121 60.5698 96.6876 51.0625C96.9359 50.3759 96.9359 49.6241 96.6876 48.9375V48.9375ZM50.0001 70.3125C45.9827 70.3125 42.0555 69.1212 38.7151 66.8892C35.3747 64.6573 32.7712 61.4849 31.2338 57.7733C29.6964 54.0616 29.2942 49.9775 30.0779 46.0372C30.8617 42.097 32.7963 38.4776 35.637 35.6369C38.4778 32.7961 42.0971 30.8616 46.0374 30.0778C49.9776 29.294 54.0618 29.6963 57.7734 31.2337C61.485 32.7711 64.6574 35.3746 66.8894 38.715C69.1213 42.0554 70.3126 45.9826 70.3126 50C70.3044 55.3847 68.1617 60.5464 64.3541 64.354C60.5466 68.1615 55.3848 70.3042 50.0001 70.3125V70.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.619e5ac68fba2aaeb93df5302a6a6dde.svg";
export { ForwardRef as ReactComponent };